<template>
  <div class="learingCourse">
      <commonHeader></commonHeader>
      <mt-navbar v-model="selected" style="margin-bottom:3px;">
        <mt-tab-item id="1" style="color:black;">小学</mt-tab-item>
        <mt-tab-item id="2" style="color:black;">中学</mt-tab-item>
        <mt-tab-item id="3" style="color:black;">大学</mt-tab-item>
      </mt-navbar>

      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="1">
         <div style="height:10px;"></div>
          <ul>
            <!-- <li v-for="item in items.smalls"  @click="goIndexTwo(item,1)" style="text-align:left;color:gray;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:14px;">{{item.name}}</span><crossLine></crossLine></li> -->
            <div @click="goIndexTwo(item,1)" v-for="item in items.smalls" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
              <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;">{{ item.name }}</span></p>
              <img :src="item.image" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
            </div>
          </ul>
          <div style="height:50px;"></div>
        </mt-tab-container-item>

        <mt-tab-container-item id="2">
          <div style="height:10px;"></div>
          <ul>
            <!-- <li v-for="item in items.middles"  @click="goIndexTwo(item,2)" style="text-align:left;color:gray;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:14px;">{{item.name}}</span><crossLine></crossLine></li> -->
            <div @click="goIndexTwo(item,2)" v-for="item in items.middles" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
              <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;">{{ item.name }}</span></p>
              <img :src="item.image" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
            </div>
          </ul>
          <div style="height:40px;"></div>
        </mt-tab-container-item>

        <mt-tab-container-item id="3">
          <div style="height:10px;"></div>
          <ul>
            <!-- <li v-for="item in items.larges"  @click="goIndexTwo(item,3)" style="text-align:left;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:16px;">{{item.name}}</span><crossLine></crossLine></li> -->
            <!-- <div @click="goIndexTwo(item,3)" v-for="item in items.larges" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
              <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;color:#8F8F94;">{{ item.name }}</span></p>
              <img :src="item.image" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
            </div> -->
            <div @click="goIndexTwo(item,3)" v-for="item in items.larges" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
              <p style="text-align:left;margin-bottom:0px;height:35px;background-color:white;padding-left:10px;"><span style="line-height:35px;font-size:16px;">{{ item.name }}</span></p>
              <img :src="item.image" alt="" style="width:100%;"  v-bind:style="{ height: heightSize + 'px' }">
            </div>
          </ul>
          <div style="height:40px;"></div>
        </mt-tab-container-item>
        
      </mt-tab-container>
  </div>
</template>
<script>

import Vue from "vue";

import openUrl from "./../utils/openUrl";

import crossLine from "./../components/cross-line.vue";
import commonHeader from "./../components/common-header.vue";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingCourse",
  data() {
    return {
  
      items:{
        smalls:[],
        middles:[],
        larges:[]
      },

      // items:{
      //   smalls: [
      //   {
      //     name: "认识我的家乡",
      //     id: "1-1",
      //     items:[
      //       {
      //         name:"市县形状与位置",
      //         id:"1-1-1",
      //         leaf:1
      //       },
      //       {
      //         name:"黑龙江省基本地理信息",
      //         id:"1-1-2",
      //         items:[
      //           {
      //             name:"资源分布",
      //             id:"1-1-2-1",
      //             leaf:1
      //           },
      //           {
      //             name:"人文历史",
      //             id:"1-1-2-2",
      //             leaf:1
      //           }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     name: "认识我的祖国",
      //     id: "1-2",
      //     items:[
      //       {
      //         name:"各省形状与位置",
      //         id:"1-2-1",
      //         leaf:1,
      //         directUrl:"http://47.240.55.250:8888/jigsaw-game-hmuv6/index.html"
      //       },
      //       {
      //         name:"我国民族分布",
      //         id:"1-2-2",
      //         leaf:1
      //       },
      //       {
      //         name:"了解地方病",
      //         id:"1-2-3",
      //         leaf:1
      //       }
      //     ]
      //   },
      //   {
      //     name: "健康教育",
      //     id: "1-3",
      //     items:[
      //       {
      //         name:"人体结构展示",
      //         id:"1-3-1",
      //         leaf:1
      //       },
      //       {
      //         name:"如何正确洗手",
      //         id:"1-3-2",
      //         leaf:1
      //       },
      //       {
      //         name:"食品营养知识",
      //         id:"1-3-3",
      //         leaf:1
      //       }
      //     ]
      //   }
      // ],
      // middles: [
      //   {
      //     name: "爱国主义教育基地",
      //     id: "2-1",
      //     items:[
      //       {
      //         name:"全国爱国主义教育基地",
      //         id:"2-1-1",
      //         leaf:1,
      //         directUrl:"http://www.hljmap.cn/hsjy/mlzg/index.html"
      //       },
      //       {
      //         name:"黑龙江爱国主义教育基地",
      //         id:"2-1-2",
      //         leaf:1,
      //         directUrl:"http://www.hljmap.cn/hsjy/mlhlj/index.html"
      //       }
      //     ]
      //   },
      //   {
      //     name: "认识世界",
      //     id: "2-2",
      //     items:[
      //       {
      //         name:"各国地图",
      //         id:"2-2-1",
      //         leaf:1
      //       },
      //       {
      //         name:"领土知识",
      //         id:"2-2-2",
      //         leaf:1,
      //         directUrl:"http://wykcug.com:8082/hmuxxbbresource/lingtu/index.html"
      //       },
      //       {
      //         name:"民族分布",
      //         id:"2-2-3",
      //         leaf:1
      //       }
      //     ]
      //   },
      //   {
      //     name: "生命教育",
      //     id: "2-3",
      //     items:[
      //       {
      //         name:"人体标本展示",
      //         id:"2-3-1",
      //         leaf:1
      //       },
      //       {
      //         name:"血压测量",
      //         id:"2-3-2",
      //         leaf:1
      //       },
      //       {
      //         name:"心肺复苏",
      //         id:"2-3-3",
      //         leaf:1
      //       },
      //       {
      //         name:"外伤处理",
      //         id:"2-3-4",
      //         leaf:1
      //       }
      //     ]
      //   }
      // ],
      // larges: [
      //   {
      //     name: "以图叙史",
      //     id: "3-1",
      //     leaf:1,
      //     directUrl:"http://47.240.55.250:8888/find-differencev21/index.html"
      //   },
      //   {
      //     name: "思政微课",
      //     id: "3-2",
      //     leaf:1,
      //     path:"/indexClass"
      //   },
      //   {
      //     name: "经典案例",
      //     id: "3-3",
      //     leaf:1,
      //     path:"/indexClassic"
      //   },
      //   {
      //     name: "考研练习",
      //     id: "3-4",
      //     leaf:1,
      //     path:"/indexKaoyan"
      //   }
      // ]
      // },
      
      heightSize: 160,
      
      selected: "1",
      imgBaseUrl: cfg.imgBaseUrl,
      isMobile:true,
    };
  },
  methods: {
    init(){
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "neItems/listNeItems"
        )
        .then(res => {
          console.log("res is:");
          console.log(res);

          // this.items=JSON.parse(res.data);
          this.items=res.data;
          console.log(this.items.smalls);
        })
        .catch(err => {
          console.log(err);
        });
    },
    goIndexTwo(item,tab) {
      this.$store.commit("updateTab", tab);

      //针对 思政微课 经典案例 考研练习 这三个特殊情况
      if(item.leaf&&item.path){
        this.$router.push({
          path:item.path
        });
        return;
      }
      //以图叙史
      if(item.leaf&&item.directUrl&&this.isMobile){
        openUrl.open(item.directUrl);
        return;
      }else{
        alert('请在手机端使用此功能，网页端占时无法使用')
      }

      console.log("got it");

      // this.$router.push({
      //   path: "/indexTwo",
      //   query: {
      //     item: JSON.stringify(item)
      //   }
      // });

      //使用 params 就是要 用name  router中的路由的name也得对上 https://blog.csdn.net/mf_717714/article/details/81945218
      this.$router.push({
        name: "indexTwo",
        params: item
      });
    },
  },
  created: function() {
    this.init();
    console.log("created");

    //mint-ui select 得是字符串  不是数字   https://blog.csdn.net/m0_37885651/article/details/80627450
    this.selected=this.$store.state.mineStore.tab.toString();
  },
  mounted: function() {
   console.log("mounted");
   let isMobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows()
        );
      }
    };
    this.isMobile=isMobile.any();
    
  },
  components: {
    crossLine,
    commonHeader
  }
};
</script>

<style lang="scss">
@import "../assets/baseScss";
.mint-navbar .mint-tab-item.is-selected {
  color: #e70202 !important;
  border-bottom: 2px solid #e70202 !important;
}

.banner {
  background-size: cover;
  width: 100%;
  min-height: 100%;
}

.learingCourse {
    .mint-tab-item-label{
      font-size:13px!important;
    }
    font-size:18px!important;
    font-weight:bold;
    color:rgb(68, 85, 102)!important;
  .courseItem {
    .item {
      display: flex;
      padding: 15px 15px 0px;

      .ico {
        flex: 1;
        margin-right: 10px;
      }
      .info {
        flex: 2;
        position: relative;
        .tit {
          text-align: left;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
        }
        .speed {
          display: flex;
          font-size: 14px;
          line-height: 30px;
          margin-top: 5px;
          width: 100%;
          a {
            flex: 2;
            color: $cl0;
            text-align: right;
            font-weight: 500;
            i:before {
              position: relative;
              top: 1px;
            }
          }
          .mt-progress {
            flex: 3;
            color: $cl9;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module-course/index.vue